import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Grid, Button } from "@material-ui/core";
import { useSelector } from "react-redux";
import SideBar from "./SideBar";
import Chatroom from "./Chatroom";
import Media from "./Media";
import Settings from "@material-ui/icons/Settings";
import VideoCam from "@material-ui/icons/Videocam";
import MediaSelect from "./MediaSelect";
import useMedia from "../hooks/useMedia";
import useChat from "../hooks/useChat";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import LinkIcon from "@material-ui/icons/Link";
import { useActions } from "../redux/useActions";
import { getRooms as getRoomsAction } from "../actions/roomActions";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2)
  },

  grid: {},

  conference: {
    width: "calc(100% - 300px)",
    padding: theme.spacing(2)

    //height: "calc(100vh - " + theme.spacing(8) + "px)",
  },

  chat: {
    width: "300px",
    height: "calc(100vh - " + theme.spacing(8) + "px)",
    backgroundColor: "#212121",
    borderLeft: "1px solid " + theme.palette.divider
  },

  videoContainer: {
    //height: "calc(100vh - 200px)",
    //maxWidth: '1200px'
    paddingTop: theme.spacing(1)
  },

  video: {
    //todo: video size breakpoints
    //maxWidth: "500px",
    width: "400px",
    height: "300px"
  },

  controlButton: {
    marginLeft: theme.spacing(1)
  },

  settings: {
    marginRight: theme.spacing(0.5)
  },

  status: {
    position: "absolute",
    left: 5,
    bottom: 0,
    zIndex: theme.zIndex.drawer + 1
  }
}));

export default function Room(props) {
  const classes = useStyles();

  const roomId = parseInt(props.match.params.roomId, 10);

  const roomState = useSelector(state => state.rooms);

  const [room, setRoom] = useState({});

  const [roomExists, setRoomExists] = useState(true);

  const [mediaSelectOpen, setMediaSelectOpen] = useState(false);

  const [
    { status, mediaElements, streaming },
    startMedia,
    stopMedia
  ] = useMedia(roomId);

  const [{ chatStatus, messages, chatSessions }, sendMessage] = useChat(roomId);

  const getRooms = useActions(() => getRoomsAction);

  useEffect(() => {
    async function getAllRooms() {
      await getRooms();
    }

    getAllRooms();
  }, []);

  useEffect(() => {
    if (roomState.rooms.length > 0) {
      const roomObject = roomState.rooms.find(r => r.roomId === roomId);
      setRoom(roomObject);

      if (roomObject === undefined) {
        setRoomExists(false);
      } else {
        setRoomExists(true);
      }
    }
  }, [roomState, roomId]);

  function closeMediaSelect() {
    setMediaSelectOpen(false);
  }

  function openMediaSelect() {
    setMediaSelectOpen(true);
  }

  return (
    <>
      <MediaSelect
        open={mediaSelectOpen}
        close={closeMediaSelect}
        join={startMedia}
      />

      {roomExists && (
        <SideBar room={room} users={chatSessions}>
          <Grid container justify="space-between" className={classes.grid}>
            <Grid item className={classes.conference}>
              <Grid container justify="space-between">
                <Grid item>
                  <Typography variant="h4" gutterBottom>
                    {room && room.name}
                  </Typography>
                </Grid>
                <Grid item>
                  <ButtonGroup
                    color="default"
                    aria-label="Outlined primary button group"
                  >
                    {!streaming && (
                      <Button
                        variant="outlined"
                        onClick={openMediaSelect}
                        disabled={status !== "Connected"}
                      >
                        <VideoCam className={classes.settings} /> Join
                        Conference
                      </Button>
                    )}
                    {streaming && (
                      <Button variant="outlined" onClick={stopMedia}>
                        <VideoCam className={classes.settings} /> Leave
                        Conference
                      </Button>
                    )}

                    <Button
                      variant="outlined"
                      className={classes.controlButton}
                    >
                      <Settings className={classes.settings} /> Options
                    </Button>
                    <Button
                      variant="outlined"
                      className={classes.controlButton}
                    >
                      <LinkIcon className={classes.settings} /> Share
                    </Button>
                  </ButtonGroup>
                </Grid>
              </Grid>
              <Grid
                container
                spacing={1}
                className={classes.videoContainer}
                justify="center"
              >
                {mediaElements.map(mediaElement => (
                  <Grid
                    item
                    key={mediaElement.connectionId}
                    className={classes.video}
                  >
                    <Media element={mediaElement} />
                  </Grid>
                ))}
              </Grid>
            </Grid>

            <Grid item className={classes.chat}>
              <Chatroom
                messages={messages}
                sendMessage={sendMessage}
                status={chatStatus}
              />
            </Grid>
          </Grid>

          <div className={classes.status}>
            <Typography variant="subtitle2" gutterBottom>
              Media: {status}
            </Typography>
            <Typography variant="subtitle2" gutterBottom>
              Chat room: {chatStatus}
            </Typography>
          </div>
        </SideBar>
      )}
      {!roomExists && (
        <div className={classes.root}>
          <Typography variant="h2" align="center">
            Room doesn't exist
          </Typography>
        </div>
      )}
    </>
  );
}
